export default "__VITE_ASSET__wnpqfxrd__"